import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * PanelBlock - A wrapper that renders a standard HTML div with Bulma class names
 *
 * This component accepts the same props as Bloomer PanelBlock for easy migration
 */
const PanelBlock = ({ className, children, style, isActive, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    return classNames('panel-block', {
      'is-active': isActive,
      [className]: className,
    });
  };

  return (
    <div className={getClassNames()} style={style} {...props}>
      {children}
    </div>
  );
};

PanelBlock.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  isActive: PropTypes.bool,
};

PanelBlock.defaultProps = {
  className: '',
  style: {},
  children: null,
  isActive: false,
};

export default PanelBlock;
